/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Nav_WarehouseInputs */

const vi_sl_nav_warehouse = /** @type {(inputs: Sl_Nav_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho phân loại`)
};

/**

* @param {Sl_Nav_WarehouseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_nav_warehouse = /** @type {((inputs?: Sl_Nav_WarehouseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Nav_WarehouseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_nav_warehouse(inputs)
});